module.exports = __webpack_public_path__ + "img/1009.f7ced4ec.jpg";